import React, { Component, Fragment } from 'react'

export default class HighlightedText extends Component {
  shouldComponentUpdate(prefProps) {
    return this.props.inputValue !== prefProps.inputValue
  }

  render() {
    const { text, inputValue } = this.props

    const inputIsEmpty = inputValue === ''
    const nameIncludesSearchValue = text
      .toLowerCase()
      .includes(inputValue.toLowerCase())

    if (inputIsEmpty || !nameIncludesSearchValue) return text

    // @improvement: move to utility
    const searchPattern = inputValue.replace(/[^a-z]/gim, '')
    const pattern = new RegExp(searchPattern, 'gi')
    const charGroup = text.replace(pattern, str => `|${str}|`).split('|')

    const highlightedText = charGroup.map((chars, i) => {
      const charMatchesName = chars.toLowerCase() === inputValue.toLowerCase()
      return charMatchesName ? <strong key={i}>{chars}</strong> : chars
    })

    return <Fragment>{highlightedText}</Fragment>
  }
}
